import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Button, Input, UncontrolledTooltip, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { WREQUESTS, SAMPLINGPOINTS, PARAMETERS } from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';

import * as url from "helpers/url_helper"
import { useHistory } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import * as be from 'helpers/backend_helper';

    const WorkRequests = () => {

        toastr.options = TOAST_OPTIONS;
        const history = useHistory()
        const [modal_request, setmodal_request] = useState(false)
        const [isEdit, setIsEdit] = useState(false)
        const [dataList, setDataList] = useState([])
        const [isLoading, setIsLoading] = useState(false)
        const [umbrellas, setUmbrellas] = useState([])

        const [umbrellaId, setUmbrellaId] = useState('')
        const [clusterId, setClusterId] = useState('')
        const [areaId, setAreaId] = useState('')
        const [schemeId, setSchemeId] = useState('')
        const [facilityId, setFacilityId] = useState('')
        const [request, setRequest] = useState('')
        const [requestedBy, setRequestedBy] = useState('')
        const [requestedByName, setRequestedByName] = useState('')
        const [dateTimeRequested, setDateTimeRequested] = useState('')
        const [requestId, setRequestId] = useState('')
        const [requestStatus, setRequestStatus] = useState('')

        const [sDate, setSDate] = useState([new Date()])
        const [eDate, setEDate] = useState([new Date()])
        const [sStatus, setSStatus] = useState('')
        const [sRegion, setSRegion] = useState('')
        const [sCluster, setSCluster] = useState('')
        const [sArea, setSArea] = useState('')
        const [sScheme, setSScheme] = useState('')
        const [sFacility, setSFacility] = useState('')

        const [statusOptions, setStatusOptions] = useState(['Open', 'Assigned', 'Closed'])
        const [assigns, setAssigns] = useState([])
        
        const [regions, setRegions] = useState([]);
        const [clusters, setClusters] = useState([]);
        const [areas, setAreas] = useState([]);
        const [schemes, setSchemes] = useState([]);
        const [facilities, setFacilities] = useState([]);

        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_request = () => {
          fetchData()
          setmodal_request(!modal_request)
          removeBodyCss()
        }
        const clearData = () =>{
          setUmbrellaId('')
          setClusterId('')
          setAreaId('')
          setFacilityId('')
          setSchemeId('')
          setRequest('')
          setDateTimeRequested('')
          setRequestStatus('')
        }
        const handleShowWR = (row) =>{
          setIsEdit(true); 
          setRequestId(row.id); 
          setAreaId(row.areaId)
          setSchemeId(row.schemeId)
          setFacilityId(row.facilityId); 
          setRequest(row.details)
          setDateTimeRequested(row.dateTime)
          setRequestedByName(row.requestedByName)
          setRequestStatus(row.status)
          tog_request();
        }
        const fetchData = () => {

          axios.get(url.REGIONS, Config).then((r)=>{ setUmbrellas(r.data); setRegions(r.data); }).catch((e)=>{  console.log(e); });
          axios.get(url.CLUSTERS, Config).then((r)=>{ setClusters(r.data); }).catch((e)=>{  console.log(e); });
          axios.get(url.AREAS, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
          axios.get(url.SCHEME, Config).then((r)=>{ setSchemes(r.data); }).catch((e)=>{  console.log(e); });
          axios.get(url.FACILITIES, Config).then((r)=>{ setFacilities(r.data) }).catch((e)=>{ console.log(e) })
          handleFilterData()
          const obj = JSON.parse(localStorage.getItem("authWTUser"));
          setRequestedBy(obj.id)
          setRequestedByName(obj.username)
        }

        useEffect(() => {
         fetchData();
        },[]);
        
        const getClusters = (u) =>{
          axios.get(`${url.CLUSTERS}?region?${u}`, Config).then((r)=>{ setClusters(r.data); }).catch((e)=>{  console.log(e); });
        }
        const getAreas = (c) =>{
          axios.get(`${url.AREAS}?cluster?${c}`, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
        }
        const getSchemes = (a) =>{
          axios.get(`${url.SCHEME}?area?${a}`, Config).then((r)=>{ setSchemes(r.data) }).catch((e)=>{ console.log(e) })
        }
        const getFacilities = (s) =>{
          axios.get(`${url.FACILITIES}?scheme?${s}`, Config).then((r)=>{ setFacilities(r.data) }).catch((e)=>{ console.log(e) })
        }
        const handleAddRequest = () =>{
          setIsEdit(false)
          tog_request()
          clearData()
        }
        const handleFilterData = () =>{
          const data = {
            id        : "",
            startDate : formatDate(sDate),
            endDate   : formatDate(eDate),
            status    : sStatus,
            region    : sRegion,
            cluster   : sCluster,
            area      : sArea,
            scheme    : sScheme,
            facility  : sFacility
          }
          setIsLoading(true)
          axios.post(url.WREQUESTSFILTER, JSON.stringify(data), Config).then((r)=>{
            setDataList(r.data)
            setIsLoading(false)
          }).catch((e)=>{
            console.log(e)
            setIsLoading(false)
          })
        }
        const handleRemoveWR = () =>{
          if(requestId){
            setIsLoading(true)
            const data = {
                  id: requestId,
                  request: request,
                  facilityId: facilityId,
                  action: "delete"
                }
                axios.post(url.WREQUESTS, JSON.stringify(data), Config).then((r)=>{
                  if(r.data.status == 1){
                    toastr.success(r.data.message)
                    tog_request()
                    clearData()
                    fetchData()
                  }else{
                    toastr.error(r.data.message)
                  }
                  setIsLoading(false)
                }).catch((e)=>{
                  console.log(e)
                  setIsLoading(false)
                })
          }else{
            toastr.error("Can not remove!")
          }
        }
 
        const handleSaveRequest = () =>{
          if(request.length > 0 && facilityId.length > 0){
            let data = {}
            if(isEdit){
              data = {
                id: requestId,
                request: request,
                facilityId: facilityId,
                action: "edit"
              }
            }else{
              data = {
                request: request,
                facilityId: facilityId,
                dateTimeReported: formatDate(new Date()),
                requestedBy: requestedBy,
                action: "add"
              }
            }
            setIsLoading(true)
            axios.post(url.WREQUESTS, JSON.stringify(data), Config).then((r)=>{
              if(r.data.status == 1){
                toastr.success(r.data.message)
                tog_request()
                clearData()
                fetchData()
              }else{
                toastr.error(r.data.message)
              }
              setIsLoading(false)
            }).catch((e)=>{
              console.log(e)
              setIsLoading(false)
            })
          }else{
            toastr.error("Provide facility and details of the request")
          }
        }
        const { SearchBar } = Search;
        const columns = [
        
        {
          dataField: 'dateTime',
          text: 'Date',
          sort: true
        }
        ,
       /* {
          dataField: 'area',
          text: 'Area',
          sort: true
        }, */
        {
          dataField: 'facility',
          text: 'Facility',
          sort: true
        },
        {
          dataField: 'details',
          text: 'Details',
          sort: true, 
          formatter: detailsFormatter
        },
        {
          dataField: 'requestedByName',
          text: 'Requested By',
          sort: true
        },
        {
          dataField: 'status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];
        function detailsFormatter(cellContent, row){
          return (
            <div>{be.truncate(cellContent)}</div>
          );
        }
        function statusFormatter(cellContent, row) {
          if (row.status == "Open") {
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else if (row.status == "Assigned"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else if (row.status == "Dropped"){
              return (
                <div>
                    <Badge className="me-2 bg-dark">
                    { cellContent }
                    </Badge>
                </div>
              );
            }else{
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function actionFormatter(cellContent, row){
          if(row.status == 'Open'){
            return(
              <>
                  <Button
                    type="button"
                    color="info"
                    className="btn-sm btn-rounded"
                    onClick={()=>{ handleShowWR(row);}}
                  >
                    Details
                  </Button>
            </>
            )
          }else{
            return(
              <>
                  <Button
                    type="button"
                    color="secondary"
                    className="btn-sm btn-rounded"
                    onClick={()=>{ handleShowWR(row) }}
                  >
                    Details
                  </Button>
            </>
            )
          }
          
        }

        return (
            <>
            <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Work Requests | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                                <Modal isOpen={modal_request} toggle={() => { tog_request(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Work request details`: `Add work request` }</h5>
                                    <button type="button"  onClick={() => { setmodal_request(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        {/*<Col md={12}>
                                            <div className="mb-3">
                                                <label>Umbrella</label>
                                                <select className="form-select" value={umbrellaId} onChange={(e)=>{setUmbrellaId(e.target.value); getClusters(e.target.value)}} disabled={isEdit?true:false}>
                                                  <option value={``}>select</option>
                                                  {umbrellas.map((f,k)=>(
                                                    <option key={k} value={f.id}>{f.region}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Cluster</label>
                                                <select className="form-select" value={clusterId} onChange={(e)=>{setClusterId(e.target.value); getAreas(e.target.value)}} disabled={isEdit?true:false}>
                                                  <option value={``}>select</option>
                                                  {clusters.map((f,k)=>(
                                                    <option key={k} value={f.id}>{f.cluster}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        */}
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Area</label>
                                                <select className="form-select" value={areaId} onChange={(e)=>{setAreaId(e.target.value); getSchemes(e.target.value); setFacilityId(''); setFacilities([])}} disabled={isEdit?true:false}>
                                                  <option value={``}>select</option>
                                                  {areas.map((f,k)=>(
                                                    <option key={k} value={f.id}>{f.name}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Scheme</label>
                                                <select className="form-select" value={schemeId} onChange={(e)=>{setSchemeId(e.target.value); getFacilities(e.target.value)}} disabled={isEdit?true:false}>
                                                  <option value={``}>select</option>
                                                  {schemes.map((f,k)=>(
                                                    <option key={k} value={f.id}>{f.scheme}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Facility</label>
                                                <select className="form-select" value={facilityId} onChange={(e)=>setFacilityId(e.target.value)} disabled={isEdit?true:false}>
                                                  <option value={``}>select facility</option>
                                                  {facilities.map((f,k)=>(
                                                    <option key={k} value={f.id}>{f.facility}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Work request details/Fault</label>
                                                <textarea rows={10} className="form-control" value={request} onChange={(e)=>setRequest(e.target.value)} disabled={isEdit?true:false}/>
                                            </div>
                                        </Col>
                                        {isEdit && (<>
                                          <Col md={12}>
                                            <div className="mb-3">
                                                <label>Date and time raised</label>
                                                <input type='text' className="form-control" defaultValue={dateTimeRequested} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Raised by</label>
                                                <input type='text' className="form-control" defaultValue={requestedByName} disabled={true}/>
                                            </div>
                                        </Col>
                                        </>)}
                                        </Row>
                                  </div>
                                  {((requestStatus == 'Open')||(requestStatus == '')) && (
                                  <div className="modal-footer justify-content-center">
                                      {!isEdit && (
                                        isLoading ? 
                                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                        : ( <button type="button" className="btn btn-danger" onClick={handleSaveRequest}>Save work request...</button> )
                                      )}
                                      {isEdit && (
                                        isLoading ? 
                                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                        : ( <button type="button" className="btn btn-success" onClick={()=>{ history.push(`/Create-WorkOrder/${be.encryptId(requestId)}`); }}>create work order/Jobcard...</button> )
                                      )}
                                      {isEdit && (
                                        isLoading ? 
                                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                        : ( <button type="button" className="btn btn-dark" onClick={handleRemoveWR}>Remove work request...</button> )
                                      )}
                                  </div>
                                  )}
                                  
                                </Modal>


                   
                      <Row>             
                        <Col lg="12">
                        <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                              

                                                <Row className="justify-content-center mb-2">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>From</label>
                                                          <Flatpickr
                                                            className="form-control form-control-sm"
                                                            options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false
                                                            }}
                                                            value={sDate}
                                                            onChange={(dates)=>setSDate(dates)}
                                                            />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Till </label>
                                                          <Flatpickr
                                                              className="form-control form-control-sm"
                                                              options={{
                                                                  dateFormat: "Y-m-d",
                                                                  enableTime: false
                                                              }}
                                                              value={eDate}
                                                              onChange={(dates)=>setEDate(dates)}
                                                              />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                          <option value=""></option>
                                                              {statusOptions.map((s,k)=>(
                                                                  <option value={s} key={k}>{s}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                
                                                  {/*
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Region</label>
                                                          <select className="form-select form-select-sm" value={sRegion} onChange={(e)=>{setSRegion(e.target.value); getClusters(e.target.value); setSCluster(''); setSArea(''); setSScheme(''); setSFacility('')}}>
                                                          <option value=""></option>
                                                              {regions.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.region}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Cluster</label>
                                                          <select className="form-select form-select-sm" value={sCluster} onChange={(e)=>{setSCluster(e.target.value); getAreas(e.target.value); setSArea(''); setSScheme(''); setSFacility('')}}>
                                                          <option value=""></option>
                                                              {clusters.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.cluster}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Area</label>
                                                          <select className="form-select form-select-sm" value={sArea} onChange={(e)=>{setSArea(e.target.value); getSchemes(e.target.value);  setSScheme(''); setSFacility('')}}>
                                                          <option value=""></option>
                                                              {areas.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  </Row>
                                                <Row  className="justify-content-center mb-2">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Scheme</label>
                                                          <select className="form-select form-select-sm" value={sScheme} onChange={(e)=>{setSScheme(e.target.value); getFacilities(e.target.value); setSFacility('')}}>
                                                          <option value=""></option>
                                                              {schemes.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.scheme}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  */}
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Facility</label>
                                                          <select className="form-select form-select-sm" value={sFacility} onChange={(e)=>setSFacility(e.target.value)}>
                                                          <option value=""></option>
                                                              {facilities.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.facility}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                 
                                                 
                                                </Row>
                                                <Row  className="justify-content-center mt-2 mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={handleAddRequest}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Raise work request
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                </div>
                                </CardBody>
                          </Card>
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Work Requests</h5>
                            <CardBody>
                            

                            {dataList && (dataList.length > 0) && (
                                <>
                                
                                <ToolkitProvider
                                      keyField="id"
                                      data={ dataList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                       
                                            
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ dataList } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>


                                </>
                            )}
                            {dataList && (dataList.length < 1) && (
                                <div className="text-center">
                                    <div className="mb-4">
                                    <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                    </div>
                                    <div>
                                    <h5>No Data Found</h5>
                                    <p className="text-muted">
                                            
                                    </p>
                                    </div>
                                    <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        onClick={handleAddRequest}
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Create work request <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                </div>

                            )}
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default WorkRequests;